import { Pipe, PipeTransform } from '@angular/core';
import { PageName } from '../models/shared.models';

const PAGE_NAME_TITLES: Record<string, string> = {
  [PageName.dashboard]: "Tableau de bord d'administration",
  [PageName.product]: 'Gestion des articles',
  [PageName.unitMeasure]: 'Gestions des unités de mésures',
  [PageName.users]: 'Gestion des utilisateurs',
  [PageName.ability]: 'Gestion des utilisateurs',
  [PageName.saleFormat]: 'Formats de ventes',
  [PageName.account]: 'Gestion du compte',
  [PageName.accountProfile]: 'Gestion du compte',
  [PageName.accountEnterpriseInfos]: "Informations de l'entreprise",
  [PageName.accountSecurity]: 'Sécurité du compte',
  [PageName.auditLogs]: 'Audit Logs',
  [PageName.importTask]: 'Tâche en cours',
  [PageName.establishment]: 'Gestions des établissements',
  [PageName.salesPoint]: 'Gestion des points de vente',
  [PageName.userProfil]: 'Gestion des utilisateurs',
  [PageName.stickers]: "Vue d'ensemble du compte sticker",
  [PageName.organizationInfos]: "Gestion d'organisation",
  [PageName.organizationSecurity]: "Gestion d'organisation",
  [PageName.organizationInvoices]: 'Liste des factures',
  [PageName.organizationUsers]: 'Liste des utilisateurs',
  [PageName.billingEquipments]: 'Gestions des équipements de facturation',
  [PageName.invoices]: 'Mes factures',
  [PageName.customerSupplier]: 'Mes partenaires',
  [PageName.invoicesIssuing]: 'Emission de facture',
  [PageName.publicInvoiceVerification]: 'Vérification de facture',
  [PageName.organizationList]: 'Liste des entreprises',
  [PageName.publicCompanyVerification]: 'Vérification de NCC',
  [PageName.taxTypes]: 'Types de taxes'
};

@Pipe({
  name: 'pageName',
  pure: true,
  standalone: true
})
export class PageNamePipe implements PipeTransform {
  transform(pageName: PageName): string {
    return PAGE_NAME_TITLES[pageName] ?? 'Inconnu';
  }
}
